import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CardContent } from "properties/propertyCard/components/PropertyCardComponents";
import { geoZonesStore } from "geoZones/_stores/geoZonesStore";

type Props = {
    geoZoneId: string;
    geoZone: {
        neighbourhood: string;
        city: string;
        provinceLong: string;
    };
};

export function CommunityCardGeozone({ geoZone, geoZoneId }: Props) {
    const { t } = useTranslation();
    const [address, setAddress] = useState<{
        neighbourhood?: string;
        city?: string;
        province?: string;
    }>({});

    useEffect(() => {
        if (geoZone) {
            setAddress({
                neighbourhood: geoZone.neighbourhood,
                city: geoZone.city,
                province: geoZone.provinceLong,
            });
        } else {
            geoZonesStore.get(geoZoneId).then((geoZone) => {
                if (geoZone) {
                    setAddress({
                        neighbourhood: geoZone.address.neighbourhood,
                        city: geoZone.address.city,
                        province: geoZone.address.provinceLong,
                    });
                }
            });
        }
    }, [geoZone, geoZoneId]);

    const sortAddress = [address.neighbourhood, address.city, address.province, t("propertyPage.country.MEX")];
    const completeAddress = sortAddress
        .filter((addressPart) => addressPart !== undefined && addressPart !== "")
        .slice(0)
        .join(", ");

    return <CardContent dangerouslySetInnerHTML={{ __html: completeAddress }} />;
}
